module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.group && _vm.group.autoInscription.method != "public" && (_vm.group.userInscriptionStatus == "" && _vm.statusPrivateKey == null)) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('globals.loading')))]) : ((_vm.group && _vm.group.autoInscription.method == "public") || (_vm.group && _vm.group.autoInscription.method == "private" && _vm.group.userInscriptionStatus != "") || _vm.hasCorrectPrivateKey) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.group.userInscriptionStatus == "LOADING") ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.$t('globals.sending')))]) : (_vm.group.userInscriptionStatus == "MEMBER") ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.autoInscription.youAreMember')))]) : (_vm.group.userInscriptionStatus == "PENDING_INVITATION") ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.autoInscription.waitConfirmation')))]) : [_c('div', {
    staticClass: "alert"
  }, [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.goToAutoInscription
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.autoInscription.joinThisGroup')))])])], _c('p', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t('groupPages.modules.autoInscription.explanation')))]), (_vm.canEdit) ? _c('p', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.goToManagement
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.createMembersModal.changeAutoInscription')))])]) : _vm._e()], 2) : _c('div', [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.autoInscription.error')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a75cbee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageNewMember.vue
// module id = 1266
// module chunks = 2